import request from "@utils/request";

export function getAlertMessageHistory(query) {
    return request({
        url: 'alert-message/history',
        method: 'post',
        data: query
    })
}

export function changeAlertMessageRating(query) {
    return request({
        url: 'alert-message/history/rating',
        method: 'put',
        data: query
    })
}